import React from 'react';
import { useTheme } from 'styled-components';

export const ModalOverlay: React.FC = () => {
    const theme = useTheme();

    return <div className="fixed inset-0 z-[1100]" style={{ backgroundColor: theme.modal.overlay.background }} />;
};
